module.exports = __webpack_public_path__ + "assets/img/discernment_pass_check_scene2.c235985c.png";